<template>
  <div class="ActivityReportingInformation">
    <el-collapse v-model="collapseNumber">
      <el-collapse-item class="collapseItem" title="活动提报信息" name="default">
        <el-form ref="form" class="form UniformCss" label-width="100px" label-position="right">
          <el-row>
            <el-col :span="6">
              <el-form-item class="formItem" label="经理部">
                <a-input v-model="data.regionName" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="false">
              <el-form-item class="formItem" label="经销商">
                <a-input v-model="data.dealerName" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="formItem" label="经销商">
                <a-input v-model="data.dealerShortName" :disabled="true" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="申请月份">
                <a-input v-model="data.actMonth" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="formItem" label="活动提报名称">
                <el-tooltip class="item" effect="dark" :content="data.planApplyName" placement="top">
                  <a-input v-model="data.planApplyName" :disabled="true" />
                </el-tooltip>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="活动提报编码">
                <a-input v-model="data.planApplyCode" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="sign-tiem" label="提报类型">
                <a-select v-model="data.itemType" :disabled="true">
                  <a-select-option v-for="(tiem, i) in SelectLists.TypesOfPresentation" :key="i" :value="tiem.code">{{tiem.value}}</a-select-option>
                </a-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="formItem" label="提报时间">
                <a-input v-model="data.applyTime" :disabled="true" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item class="act-item" label="计划开始日期">
                <a-date-picker v-model="data.planStartTime" type="date" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="act-item" label="计划结束日期">
                <a-date-picker v-model="data.planEndTime" type="date" disabled />
              </el-form-item>
            </el-col>
            <!-- 弃用 -->
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="执行数量">
                <a-input v-model="data.executeNums" :disabled="true" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="活动预算(元)">
                <a-input v-model="formattedActBudget" :disabled="true" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="品系">
                <a-input v-model="data.strainsName" :disabled="true" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item class="sign-tiem" label="提报状态">
                <a-select v-model="data.applyStatus" :disabled="true">
                  <a-select-option v-for="(tiem, i) in SelectLists.ActPlanApplyStatus" :key="i" :value="tiem.code">{{tiem.value}}</a-select-option>
                </a-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="formItem" label="集客目标">
                <a-input v-model="data.customerTarget" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="formItem" label="订单目标">
                <a-input v-model="data.orderTarget" :disabled="true" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item class="formItem" label="实际集客">
                <a-input v-model="data.customerActual" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="formItem" label="实际订单">
                <a-input v-model="data.orderActual" :disabled="true" />
              </el-form-item>
            </el-col> -->
          </el-row>
          <component :is="getFormByActivity(activity.threeLevelName)" ref="activityForm" :formData="data" formType="detail" :priceDiff="priceDiff"></component>
          <el-row>
            <el-col :span="18" style="height: auto">
              <el-form-item class="pp" label="计划方案">
                <el-upload
                  ref="uploadFile"
                  class="upload-demo"
                  action=""
                  :on-preview="onPreviewFun"
                  :auto-upload="false"
                  :file-list="fileList"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 预算类型查询 -->
        <!-- <div class="table">
          <vxe-table
            border
            align="center"
            show-header-overflow
            show-overflow
            class="mytable-scrollbar"
            :column-config="{ resizable: true }"
            stripe
            round
            style="margin-top: 10px"
            :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
            :scroll-y="{ enabled: false }"
            :row-config="{ isHover: true }"
            :data="CarfindList"
          >
            <vxe-column type="seq" title="序号" width="60" align="center" />
            <vxe-column title="品系" field="strains" />
            <vxe-column title="车系" field="carSeries" />
            <vxe-column title="集客目标" field="customerTarget" />
            <vxe-column title="订单目标" field="orderTarget" />
            <vxe-column title="备注" field="remarks" />
          </vxe-table>
          <vxe-pager
            :current-page="pagination.current"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="pageFun"
          /> -->

          <!-- <el-pagination background layout="->,prev, pager, next" :total="50"></el-pagination> -->
        <!-- </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
// import { findPlanCustomers, getFileByte2 } from '@/api/actPlan'
import { findPlanCustomers} from '@/api/actPlan'

import { http } from '@/api/activityCheck.js'
// import Filedownload from '@/components/files/index'
import { toThousandNumFilter } from '@/filters/index.js'
import { activityFormMap } from '@/utils/index.js'
import form1 from '../components/activityForm/components/form1.vue';
import form2 from '../components/activityForm/components/form2.vue';
import form3 from '../components/activityForm/components/form3.vue';
import form4 from '../components/activityForm/components/form4.vue';
import form5 from '../components/activityForm/components/form5.vue';
import form7 from '../components/activityForm/components/form7.vue';

export default {
  name: 'ActivityReportingInformation',
  // components: { Filedownload },
  components:{ form1, form2, form3, form4, form5, form7},
  props: ['data', 'activity', 'fileList', 'approveBtnType', 'priceDiff'],
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10
      },
      form: {},
      collapseNumber: 'default',
      ids: {},
      CarfindList: [], // 车列表,
      planApplyId: null,
      SelectLists: {},
      officeTypeList: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
    }
  },
  computed: {
    formattedActBudget() {
      return toThousandNumFilter(this.data.actBudget)
    }
  },
  created() {
    if (this.$route.params.id) {
      this.planApplyId = this.$route.params.id
      this.getCollectqtyById()
    }
    this.SelectListsFun()
  },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['ActPlanApplyStatus', 'TypesOfPresentation']).then(v => {
        this.SelectLists = v
      })
    },
    getCollectqtyById() {
      const data = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        planApplyId: this.planApplyId
      }
      findPlanCustomers(data).then(res => {
        if (res.code === 1 && res.data) {
          this.CarfindList = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 文件下载
    FineDownloadFun(fine) {
      // 创建一个下载标签<a>
      const aLink = document.createElement('a')
      aLink.href = fine.blob

      // 2.直接使用自定义文件名,设置下载文件名称
      aLink.setAttribute('download', fine.name)
      document.body.appendChild(aLink)

      // 模拟点击下载
      aLink.click()

      // 移除改下载标签
      document.body.removeChild(aLink)
    },
    toFullUrl(url) {
      if (!url) return '';
      if (/^https?:\/\//i.test(url)) return url;
      const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/,'');
      const path = String(url).replace(/^\/+/, '');
      return base ? `${base}/${path}` : `/${path}`;
    },
    onPreviewFun(e) {
      const full = this.toFullUrl(e && e.url);
      if (full) window.open(full, '_blank');
    },
    pageFun({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.pageSize && (this.pagination.current = 1)
      this.pagination.pageSize = pageSize
      this.getCollectqtyById()
    },

    GetCarFun() {
      http
        .CarfindList({
          page: this.pagination.current,
          limit: this.pagination.pageSize,
          marketactid: this.ids.marketactid
        })
        .then(val => {
          this.CarfindList = val.data.list
          this.pagination.total = val.data.total
        })
    },
    // 图片文件获取方法
    downloadFiles(obj) {
      return new Promise(resolve => {
        const path = obj.path
        const fileName = obj.name
        http.download({ path, fileName }).then(blob => {
          resolve(window.URL.createObjectURL(blob))
        })
      })
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(activityType) {
      console.log(activityType,'----activityType--1111--00----');
      
      // 遍历映射对象
      for (const form in activityFormMap) {
          // 检查活动类型是否在当前表单类型的数组中
          if (activityFormMap[form].includes(activityType)) {
          return form;
          }
      }
      // 如果没有找到对应的表单，返回"未知表单"
      return "form1";
    },

  }
}
</script>
<style lang="less">
.collapseItem {
  .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .el-collapse-item__content {
    padding-top: 20px;
    padding-right: 20px;
  }
}</style>
<style lang="less" scoped>
.ActivityReportingInformation {
  font-size: 16px;
  border: 1px solid #cccccc;
  border-top: none;
  p {
    background: #0a76a4;
    color: white;
    padding: 6px 20px;
    margin: 0 0 20px;
  }
  .inputH {
    .a-input__inner {
      height: 60px;
    }
  }
  // .form {
  //   padding: 0 20px 0 0;
  // }
  .el-form-item--medium {
    margin: 0 0 10px 0;
  }
  .formItem {
    span {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
    }
  }
  .pp {
    float: left;
    padding: 0 60% 0 0;
    margin: 0;
  }

  .table {
    // margin: 10px 25px;
    padding: 10px;
  }
  .finesDownload {
    margin: 0 0 10px;
    span {
      margin: 0 20px 0 0;
      color: #686868;
      font-weight: bold;
    }
  }
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  width: 100%;
}

</style>
